import { useParams } from "react-router-dom";
import { ProjectDetail } from "@/components/project-detail";

export function ProjectPage() {
  const { id = "" } = useParams();
  return <ProjectDetail id={id} />;
}
